<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [SendSmsContract]
 * Модальное окно / экран "Ура! Все готово! Отправить СМС-контракт"
 */

// Hooks
import { ref } from "vue";

// Components
import Modal from "@/components/modal/modal.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
// Icons
import AwardIcon from "@/ui/icons/award.vue";
import { BugTrackerSection, useBugTracker } from "~/tiw/helpers/bugTracker";
import it4SendContractToSign from "~/tiw/hooks/requests/it4SendContractToSign/it4SendContractToSign";
import { useHowYouRateDeviceStore } from "~/tiw/stores/howYouRateDevice/howYouRateDevice";
import { useSuccessfulEvaluationStore } from "~/tiw/stores/successfulEvaluation/successfulEvaluation";

const TIWStore = useTIWStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const SuccessfulEvaluationStore = useSuccessfulEvaluationStore();

const loadingToNext = ref<boolean>(false);

async function onSendSms() {
    loadingToNext.value = true;

    try {
        it4SendContractToSign({
            token: TIWStore.WIDGET_DATA.token,
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            contractNumber: SuccessfulEvaluationStore.contractData.contractNumber,
        });
    } catch (e) {
        useBugTracker("Send Contract", BugTrackerSection.ERROR, {
            message: e?.message,
        });
    }

    loadingToNext.value = false;
    TIWStore.switchStep("confirmSigned");
}
</script>

<template>
    <Modal class="tiw__step__sendSmsContract">
        <template #header>
            <p class="tiw__step__sendSmsContract__header tiw__h2">
                <AwardIcon />
                {{ useTranslate("tiw__sendSmsContract__title") }}
            </p>
            <p>
                {{ useTranslate("tiw__sendSmsContract__subtitle") }}
            </p>
        </template>

        <div class="tiw__step__sendSmsContract__body">
            <Button
                type="button"
                class="tiw__step__sendSmsContract__btn-send"
                :disabled="loadingToNext"
                :loading="loadingToNext"
                @click="onSendSms"
            >
                <span>
                    {{ useTranslate("tiw__sendSmsContract__sendContract") }}
                </span>
            </Button>
        </div>
    </Modal>
</template>

<style lang="scss" src="./sendSmsContract.scss"></style>
